import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/transactions.js';
import form from '../forms/transactions.js';
import * as types from '../types.js';

const transactions = function()
{

	let transactions_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_warehouses, this.queryAll()).then((data) => db.set('warehouses', data).catch(error => notify(error)));
			api.call(api.list_locations, this.queryAll()).then((data) => db.set('locations', data).catch(error => notify(error)));
			api.call(api.list_products, this.queryAll()).then((data) => db.set('products', data).catch(error => notify(error)));
			api.call(api.list_lots, this.queryAll()).then((data) => db.set('lots', data).catch(error => notify(error)));
			api.call(api.list_users, this.queryAll()).then((data) => db.set('users', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_transactions, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_transaction, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				product_id: Number(data.product_id),
				lot_id: Number(data.lot_id),
				source_type: data.source_type,
				target_type: data.target_type,
				source: JSON.parse(data.source),
				target: JSON.parse(data.target),
				quantity: Number(data.quantity),
				value: Number(data.value),
			};
			if (old_data)
				_record.movement_kind = data.movement_kind || null;
			else if (data.movement_kind)
				_record.movement_kind = data.movement_kind;
			if (old_data)
				return await api.call(api.update_transaction, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_transaction, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Transação', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador da transação' },
		{ index: 3, field: 'product_id', label: 'Produto', types: [types.datalist()], placeholder: '', title: 'Produto', store: 'products', labels: ['name'] },
		{ index: 4, field: 'lot_id', label: 'Lote', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do lote' },
		{ index: 5, field: 'user_id', label: 'Usuário', types: [types.datalist()], placeholder: '', title: 'Usuário', store: 'users', labels: ['name'] },
		{ index: 6, field: 'date_time', label: 'Data/Hora', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora da transação' },
		{ index: 7, field: 'source_type', label: 'Tipo Origem',	types: [types.opt_transaction_type(), types.datalist()], placeholder: '', title: 'Tipo de origem' },
		{ index: 8, field: 'target_type', label: 'Tipo Destino',	types: [types.opt_transaction_type(), types.datalist()], placeholder: '', title: 'Tipo de destino' },
		{ index: 9, field: 'source', label: 'Origem', types: [], placeholder: '', title: 'Identificação da origem' },
		{ index: 10, field: 'target', label: 'Destino', types: [], placeholder: '', title: 'Identificação do destino' },
		{ index: 11, field: 'quantity', label: 'Quantidade', types: [types.number(0, 2)], placeholder: '0', title: 'Quantidade' },
		{ index: 12, field: 'movement_kind', label: 'Natureza', types: [types.opt_movement_kind()], placeholder: '', title: 'MOV / RESUP / …' },
		{ index: 13, field: 'value', label: 'Valor', types: [types.number(2)], placeholder: '0,00', title: 'Valor' },
	];

	transactions_crud.run(
		'transactions',
		'Transações',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default transactions;

